import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=ff6cd394&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
import style0 from "./Switch.vue?vue&type=style&index=0&id=ff6cd394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6cd394",
  null
  
)

component.options.__file = "Switch.vue"
export default component.exports